//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./account.d.ts" />

import * as $ from "skir-client";
import * as x_competitor from "./competitor.js";
import * as x_crm from "./crm.js";
import * as x_methodology from "./methodology.js";
import * as x_package from "./package.js";
import * as x_todo from "./todo.js";

// -----------------------------------------------------------------------------
// struct Account.BotImage
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `Account.BotImage.Mutable`.
 *
 * @alias Account.BotImage
 */
class Account_BotImage extends $._FrozenBase {}

function initAccount_BotImage(target, initializer) {
  target.blobPath = initializer.blobPath ?? "";
  target.mimeType = initializer.mimeType ?? "";
  target.publicUrl = initializer.publicUrl ?? "";
}

// -----------------------------------------------------------------------------
// enum Account.Industry
// -----------------------------------------------------------------------------

/**
 * Deeply immutable.
 *
 * @alias Account.Industry
 */
class Account_Industry extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct Account.SlackChatIntegration
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `Account.SlackChatIntegration.Mutable`.
 *
 * @alias Account.SlackChatIntegration
 */
class Account_SlackChatIntegration extends $._FrozenBase {}

function initAccount_SlackChatIntegration(target, initializer) {
  target.botToken = initializer.botToken ?? "";
  target.teamId = initializer.teamId ?? "";
  target.teamName = initializer.teamName ?? "";
}

// -----------------------------------------------------------------------------
// struct Account.NotionExportIntegration
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `Account.NotionExportIntegration.Mutable`.
 *
 * @alias Account.NotionExportIntegration
 */
class Account_NotionExportIntegration extends $._FrozenBase {}

function initAccount_NotionExportIntegration(target, initializer) {
  target.token = initializer.token ?? "";
  target.refreshToken = initializer.refreshToken ?? "";
  target.botId = initializer.botId ?? "";
  target.workspaceId = initializer.workspaceId ?? "";
  target.workspaceName = initializer.workspaceName ?? "";
  target.targetPageId = initializer.targetPageId ?? "";
  target.targetDatabaseId = initializer.targetDatabaseId ?? "";
  target.targetName = initializer.targetName ?? "";
}

// -----------------------------------------------------------------------------
// struct Account.NotionHandoffIntegration.ClinicPropertyEntry
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `Account.NotionHandoffIntegration.ClinicPropertyEntry.Mutable`.
 *
 * @alias Account.NotionHandoffIntegration.ClinicPropertyEntry
 */
class Account_NotionHandoffIntegration_ClinicPropertyEntry extends $._FrozenBase {}

function initAccount_NotionHandoffIntegration_ClinicPropertyEntry(target, initializer) {
  target.notionProperty = initializer.notionProperty ?? "";
  target.source = initializer.source ?? "";
  target.type = initializer.type ?? "";
}

// -----------------------------------------------------------------------------
// struct Account.NotionHandoffIntegration
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `Account.NotionHandoffIntegration.Mutable`.
 *
 * @alias Account.NotionHandoffIntegration
 */
class Account_NotionHandoffIntegration extends $._FrozenBase {}

function initAccount_NotionHandoffIntegration(target, initializer) {
  target.enabled = initializer.enabled ?? false;
  target.clinicDatabaseId = initializer.clinicDatabaseId ?? "";
  target.checklistTemplatePageId = initializer.checklistTemplatePageId ?? "";
  target.clinicTitleProperty = initializer.clinicTitleProperty ?? "";
  target.clinicPropertyMap = $._toFrozenArray(
    initializer.clinicPropertyMap || [],
    Account_NotionHandoffIntegration_ClinicPropertyEntry.create,
  );
}

// -----------------------------------------------------------------------------
// struct Account.AircallIntegration
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `Account.AircallIntegration.Mutable`.
 *
 * @alias Account.AircallIntegration
 */
class Account_AircallIntegration extends $._FrozenBase {}

function initAccount_AircallIntegration(target, initializer) {
  target.accessToken = initializer.accessToken ?? "";
  target.connectedAt = initializer.connectedAt ?? $.Timestamp.UNIX_EPOCH;
  target.status = initializer.status ?? "";
  target.webhookId = initializer.webhookId ?? "";
  target.webhookToken = initializer.webhookToken ?? "";
}

// -----------------------------------------------------------------------------
// struct Account.GongIntegration
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `Account.GongIntegration.Mutable`.
 *
 * @alias Account.GongIntegration
 */
class Account_GongIntegration extends $._FrozenBase {}

function initAccount_GongIntegration(target, initializer) {
  target.accessKey = initializer.accessKey ?? "";
  target.accessKeySecret = initializer.accessKeySecret ?? "";
  target.connectedAt = initializer.connectedAt ?? $.Timestamp.UNIX_EPOCH;
  target.status = initializer.status ?? "";
  target.lastSyncAt = initializer.lastSyncAt ?? null;
  target.baseUrl = initializer.baseUrl ?? "";
}

// -----------------------------------------------------------------------------
// struct Account.FathomIntegration
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `Account.FathomIntegration.Mutable`.
 *
 * @alias Account.FathomIntegration
 */
class Account_FathomIntegration extends $._FrozenBase {}

function initAccount_FathomIntegration(target, initializer) {
  target.apiKey = initializer.apiKey ?? "";
  target.connectedAt = initializer.connectedAt ?? $.Timestamp.UNIX_EPOCH;
  target.status = initializer.status ?? "";
  target.lastSyncAt = initializer.lastSyncAt ?? null;
  target.baseUrl = initializer.baseUrl ?? "";
}

// -----------------------------------------------------------------------------
// struct Account.GranolaIntegration
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `Account.GranolaIntegration.Mutable`.
 *
 * @alias Account.GranolaIntegration
 */
class Account_GranolaIntegration extends $._FrozenBase {}

function initAccount_GranolaIntegration(target, initializer) {
  target.apiKey = initializer.apiKey ?? "";
  target.connectedAt = initializer.connectedAt ?? $.Timestamp.UNIX_EPOCH;
  target.status = initializer.status ?? "";
  target.lastSyncAt = initializer.lastSyncAt ?? null;
  target.baseUrl = initializer.baseUrl ?? "";
}

// -----------------------------------------------------------------------------
// struct Account.VoiceBiometricSettings
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `Account.VoiceBiometricSettings.Mutable`.
 *
 * @alias Account.VoiceBiometricSettings
 */
class Account_VoiceBiometricSettings extends $._FrozenBase {}

function initAccount_VoiceBiometricSettings(target, initializer) {
  target.enabled = initializer.enabled ?? false;
  target.maxSamplesPerSpeaker = initializer.maxSamplesPerSpeaker ?? BigInt(0);
  target.minUtteranceDuration = initializer.minUtteranceDuration ?? 0;
  target.confidenceThreshold = initializer.confidenceThreshold ?? 0;
}

// -----------------------------------------------------------------------------
// struct Account.TodoKindSettings
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `Account.TodoKindSettings.Mutable`.
 *
 * @alias Account.TodoKindSettings
 */
class Account_TodoKindSettings extends $._FrozenBase {}

function initAccount_TodoKindSettings(target, initializer) {
  target.disabledCategories = $._toFrozenArray(
    initializer.disabledCategories || [],
    x_todo.TodoCategory.create,
  );
  target.disabledSources = $._toFrozenArray(
    initializer.disabledSources || []);
    target.disabledActionKinds = $._toFrozenArray(
      initializer.disabledActionKinds || []);
      target.visibleActionKinds = $._toFrozenArray(
        initializer.visibleActionKinds || []);
}

// -----------------------------------------------------------------------------
// struct Account
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `Account.Mutable`. */
export class Account extends $._FrozenBase {}

function initAccount(target, initializer) {
  target.id = initializer.id ?? BigInt(0);
  target.name = initializer.name ?? "";
  target.botName = initializer.botName ?? "";
  target.botImage = Account_BotImage.create(initializer.botImage ?? Account_BotImage.DEFAULT);
  target.industry = Account_Industry.create(initializer.industry ?? Account_Industry.UNKNOWN);
  target.description = initializer.description ?? "";
  target.slackChatConnected = initializer.slackChatConnected ?? false;
  target.slackChatIntegration = Account_SlackChatIntegration.create(initializer.slackChatIntegration ?? Account_SlackChatIntegration.DEFAULT);
  target.methodologies = $._toFrozenArray(
    initializer.methodologies || [],
    x_methodology.Methodology.create,
  );
  target.crmIntegration = initializer.crmIntegration ? x_crm.CrmIntegration.create(initializer.crmIntegration) : null;
  target.aircallIntegration = initializer.aircallIntegration ? Account_AircallIntegration.create(initializer.aircallIntegration) : null;
  target.domains = $._toFrozenArray(
    initializer.domains || []);
    target.gongIntegration = initializer.gongIntegration ? Account_GongIntegration.create(initializer.gongIntegration) : null;
    target.competitors = $._toFrozenArray(
      initializer.competitors || [],
      x_competitor.Competitor.create,
    );
    target.voiceBiometricSettings = initializer.voiceBiometricSettings ? Account_VoiceBiometricSettings.create(initializer.voiceBiometricSettings) : null;
    target.defaultPackageTier = x_package.PackageTier.create(initializer.defaultPackageTier ?? x_package.PackageTier.UNKNOWN);
    target.maxSeats = initializer.maxSeats ?? null;
    target.notionExportConnected = initializer.notionExportConnected ?? false;
    target.notionExportIntegration = Account_NotionExportIntegration.create(initializer.notionExportIntegration ?? Account_NotionExportIntegration.DEFAULT);
    target.notionHandoffIntegration = Account_NotionHandoffIntegration.create(initializer.notionHandoffIntegration ?? Account_NotionHandoffIntegration.DEFAULT);
    target.fathomIntegration = initializer.fathomIntegration ? Account_FathomIntegration.create(initializer.fathomIntegration) : null;
    target.granolaIntegration = initializer.granolaIntegration ? Account_GranolaIntegration.create(initializer.granolaIntegration) : null;
    target.todoKindSettings = Account_TodoKindSettings.create(initializer.todoKindSettings ?? Account_TodoKindSettings.DEFAULT);
}

// -----------------------------------------------------------------------------
// struct AccountMethodologyList
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `AccountMethodologyList.Mutable`. */
export class AccountMethodologyList extends $._FrozenBase {}

function initAccountMethodologyList(target, initializer) {
  target.methodologies = x_methodology.MethodologyList.create(initializer.methodologies ?? x_methodology.MethodologyList.DEFAULT);
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "account.skir",
  [
    {
      kind: "struct",
      ctor: Account_BotImage,
      initFn: initAccount_BotImage,
      name: "BotImage",
      parentCtor: Account,
      fields: [
        {
          name: "blob_path",
          property: "blobPath",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "mime_type",
          property: "mimeType",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "public_url",
          property: "publicUrl",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: Account_Industry,
      name: "Industry",
      parentCtor: Account,
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "OTHER",
          number: 1,
        },
        {
          name: "SAAS",
          number: 2,
        },
        {
          name: "ECOMMERCE",
          number: 3,
        },
        {
          name: "HEALTHCARE",
          number: 4,
        },
        {
          name: "FINTECH",
          number: 5,
        },
        {
          name: "EDUCATION",
          number: 6,
        },
        {
          name: "MARKETING_AGENCY",
          number: 7,
        },
        {
          name: "MEDIA",
          number: 8,
        },
        {
          name: "LOGISTICS",
          number: 9,
        },
        {
          name: "ENERGY",
          number: 10,
        },
        {
          name: "PROFESSIONAL_SERVICES",
          number: 11,
        },
        {
          name: "GOVERNMENT",
          number: 12,
        },
        {
          name: "NONPROFIT",
          number: 13,
        },
        {
          name: "MANUFACTURING",
          number: 14,
        },
        {
          name: "REAL_ESTATE",
          number: 15,
        },
        {
          name: "AI_COMPANY",
          number: 16,
        },
      ],
    },
    {
      kind: "struct",
      ctor: Account_SlackChatIntegration,
      initFn: initAccount_SlackChatIntegration,
      name: "SlackChatIntegration",
      parentCtor: Account,
      fields: [
        {
          name: "bot_token",
          property: "botToken",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "team_id",
          property: "teamId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "team_name",
          property: "teamName",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: Account_NotionExportIntegration,
      initFn: initAccount_NotionExportIntegration,
      name: "NotionExportIntegration",
      parentCtor: Account,
      fields: [
        {
          name: "token",
          property: "token",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "refresh_token",
          property: "refreshToken",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "bot_id",
          property: "botId",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "workspace_id",
          property: "workspaceId",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "workspace_name",
          property: "workspaceName",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "target_page_id",
          property: "targetPageId",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "target_database_id",
          property: "targetDatabaseId",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "target_name",
          property: "targetName",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: Account_NotionHandoffIntegration_ClinicPropertyEntry,
      initFn: initAccount_NotionHandoffIntegration_ClinicPropertyEntry,
      name: "ClinicPropertyEntry",
      parentCtor: Account_NotionHandoffIntegration,
      fields: [
        {
          name: "notion_property",
          property: "notionProperty",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "source",
          property: "source",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "type",
          property: "type",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: Account_NotionHandoffIntegration,
      initFn: initAccount_NotionHandoffIntegration,
      name: "NotionHandoffIntegration",
      parentCtor: Account,
      fields: [
        {
          name: "enabled",
          property: "enabled",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "clinic_database_id",
          property: "clinicDatabaseId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "checklist_template_page_id",
          property: "checklistTemplatePageId",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "clinic_title_property",
          property: "clinicTitleProperty",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "clinic_property_map",
          property: "clinicPropertyMap",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: Account_NotionHandoffIntegration_ClinicPropertyEntry,
            },
          },
          mutableGetter: "mutableClinicPropertyMap",
        },
      ],
    },
    {
      kind: "struct",
      ctor: Account_AircallIntegration,
      initFn: initAccount_AircallIntegration,
      name: "AircallIntegration",
      parentCtor: Account,
      fields: [
        {
          name: "access_token",
          property: "accessToken",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "connected_at",
          property: "connectedAt",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "status",
          property: "status",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "webhook_id",
          property: "webhookId",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "webhook_token",
          property: "webhookToken",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: Account_GongIntegration,
      initFn: initAccount_GongIntegration,
      name: "GongIntegration",
      parentCtor: Account,
      fields: [
        {
          name: "access_key",
          property: "accessKey",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "access_key_secret",
          property: "accessKeySecret",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "connected_at",
          property: "connectedAt",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "status",
          property: "status",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "last_sync_at",
          property: "lastSyncAt",
          number: 4,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "base_url",
          property: "baseUrl",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: Account_FathomIntegration,
      initFn: initAccount_FathomIntegration,
      name: "FathomIntegration",
      parentCtor: Account,
      fields: [
        {
          name: "api_key",
          property: "apiKey",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "connected_at",
          property: "connectedAt",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "status",
          property: "status",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "last_sync_at",
          property: "lastSyncAt",
          number: 3,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "base_url",
          property: "baseUrl",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: Account_GranolaIntegration,
      initFn: initAccount_GranolaIntegration,
      name: "GranolaIntegration",
      parentCtor: Account,
      fields: [
        {
          name: "api_key",
          property: "apiKey",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "connected_at",
          property: "connectedAt",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "status",
          property: "status",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "last_sync_at",
          property: "lastSyncAt",
          number: 3,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "base_url",
          property: "baseUrl",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: Account_VoiceBiometricSettings,
      initFn: initAccount_VoiceBiometricSettings,
      name: "VoiceBiometricSettings",
      parentCtor: Account,
      fields: [
        {
          name: "enabled",
          property: "enabled",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "max_samples_per_speaker",
          property: "maxSamplesPerSpeaker",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "min_utterance_duration",
          property: "minUtteranceDuration",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "float32",
          },
        },
        {
          name: "confidence_threshold",
          property: "confidenceThreshold",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "float32",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: Account_TodoKindSettings,
      initFn: initAccount_TodoKindSettings,
      name: "TodoKindSettings",
      parentCtor: Account,
      fields: [
        {
          name: "disabled_categories",
          property: "disabledCategories",
          number: 0,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: x_todo.TodoCategory,
            },
          },
          mutableGetter: "mutableDisabledCategories",
        },
        {
          name: "disabled_sources",
          property: "disabledSources",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableDisabledSources",
        },
        {
          name: "disabled_action_kinds",
          property: "disabledActionKinds",
          number: 2,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableDisabledActionKinds",
        },
        {
          name: "visible_action_kinds",
          property: "visibleActionKinds",
          number: 3,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableVisibleActionKinds",
        },
      ],
    },
    {
      kind: "struct",
      ctor: Account,
      initFn: initAccount,
      name: "Account",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "name",
          property: "name",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "bot_name",
          property: "botName",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "bot_image",
          property: "botImage",
          number: 3,
          type: {
            kind: "record",
            ctor: Account_BotImage,
          },
          mutableGetter: "mutableBotImage",
        },
        {
          name: "industry",
          property: "industry",
          number: 4,
          type: {
            kind: "record",
            ctor: Account_Industry,
          },
        },
        {
          name: "description",
          property: "description",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "slack_chat_connected",
          property: "slackChatConnected",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "slack_chat_integration",
          property: "slackChatIntegration",
          number: 7,
          type: {
            kind: "record",
            ctor: Account_SlackChatIntegration,
          },
          mutableGetter: "mutableSlackChatIntegration",
        },
        {
          name: "methodologies",
          property: "methodologies",
          number: 8,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: x_methodology.Methodology,
            },
          },
          mutableGetter: "mutableMethodologies",
        },
        {
          name: "crm_integration",
          property: "crmIntegration",
          number: 9,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: x_crm.CrmIntegration,
            },
          },
        },
        {
          name: "aircall_integration",
          property: "aircallIntegration",
          number: 10,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: Account_AircallIntegration,
            },
          },
        },
        {
          name: "domains",
          property: "domains",
          number: 11,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableDomains",
        },
        {
          name: "gong_integration",
          property: "gongIntegration",
          number: 12,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: Account_GongIntegration,
            },
          },
        },
        {
          name: "competitors",
          property: "competitors",
          number: 13,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: x_competitor.Competitor,
            },
          },
          mutableGetter: "mutableCompetitors",
        },
        {
          name: "voice_biometric_settings",
          property: "voiceBiometricSettings",
          number: 14,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: Account_VoiceBiometricSettings,
            },
          },
        },
        {
          name: "default_package_tier",
          property: "defaultPackageTier",
          number: 15,
          type: {
            kind: "record",
            ctor: x_package.PackageTier,
          },
        },
        {
          name: "max_seats",
          property: "maxSeats",
          number: 16,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "int32",
            },
          },
        },
        {
          name: "notion_export_connected",
          property: "notionExportConnected",
          number: 17,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "notion_export_integration",
          property: "notionExportIntegration",
          number: 18,
          type: {
            kind: "record",
            ctor: Account_NotionExportIntegration,
          },
          mutableGetter: "mutableNotionExportIntegration",
        },
        {
          name: "notion_handoff_integration",
          property: "notionHandoffIntegration",
          number: 19,
          type: {
            kind: "record",
            ctor: Account_NotionHandoffIntegration,
          },
          mutableGetter: "mutableNotionHandoffIntegration",
        },
        {
          name: "fathom_integration",
          property: "fathomIntegration",
          number: 20,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: Account_FathomIntegration,
            },
          },
        },
        {
          name: "granola_integration",
          property: "granolaIntegration",
          number: 21,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: Account_GranolaIntegration,
            },
          },
        },
        {
          name: "todo_kind_settings",
          property: "todoKindSettings",
          number: 22,
          type: {
            kind: "record",
            ctor: Account_TodoKindSettings,
          },
          mutableGetter: "mutableTodoKindSettings",
        },
      ],
    },
    {
      kind: "struct",
      ctor: AccountMethodologyList,
      initFn: initAccountMethodologyList,
      name: "AccountMethodologyList",
      fields: [
        {
          name: "methodologies",
          property: "methodologies",
          number: 0,
          type: {
            kind: "record",
            ctor: x_methodology.MethodologyList,
          },
          mutableGetter: "mutableMethodologies",
        },
      ],
    },
  ]
);
